import { markerRegex, markerSyntax } from '~globals';
import { Mark, MarkProps } from '~components/Mark';
import { splitStringAtRegexMatch } from './string';

export const applyMarker = (content: string, options: Pick<MarkProps, 'markerColor' | 'animated'> = {}) =>
  splitStringAtRegexMatch(content, markerRegex).map((fragment, i) =>
    markerRegex.test(fragment) ? (
      <Mark key={`${i}-${fragment}`} markerColor='var(--markerColor)' {...options}>
        {fragment.split(markerSyntax)[1]}
      </Mark>
    ) : (
      fragment
    ),
  );
